import React from 'react';
import classNames from 'classnames';

import Image, { LazyImageControlProps } from 'vibo-ui/Image';

import { ReactComponent as UserIcon } from 'resources/img/svg/common/user.svg';

import { getFullName } from 'services/users/helpers';

import useStyles from '../style';

interface CroppedUserImageProps extends LazyImageControlProps {
  user: Maybe<UserBase>;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const CroppedUserImage = ({ user, className, onClick, isLazy, ...rest }: CroppedUserImageProps) => {
  const classes = useStyles();
  const alt = user ? getFullName(user) : '';
  const cropped = user?.image?.cropped;

  return (
    <Image
      onClick={onClick}
      src={cropped?.small || cropped?.medium || user?.imageUrl || ''}
      alt={alt}
      gradientId={user?._id}
      className={classNames(classes.img, className)}
      isLazy={isLazy}
      {...rest}
    >
      <UserIcon />
    </Image>
  );
};

export default CroppedUserImage;
